import React, { FC, ReactNode } from "react"
import L10n from "../../../lib/carrot-l10n"
import Title from "../Title"
import { MultiPathSVG } from "../SVG"
import styled from "styled-components"
import { Container, FlexContainer } from "@carrotfertility/carotene"
import { useHistory } from "react-router"

const MainContainer = styled(Container)({
  border: "solid .125rem white",
  width: "600px",
  borderRadius: "8px",
  "@media screen and (max-width: 599px)": {
    minHeight: "100vh"
  }
})

const LayoutBindHeight = styled.div({
  minHeight: "100vh",
  paddingBottom: "48px"
})

export function FleContinueWrapper({ children }: { children: ReactNode }): JSX.Element {
  const oneChild = React.Children.toArray(children).length === 1
  return (
    <FlexContainer
      paddingLeftRight="huge"
      paddingTopBottom="huge"
      justifyContent={oneChild ? "flex-end" : "space-between"}
    >
      {children}
    </FlexContainer>
  )
}

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

type FleLayoutProps = {
  children: ReactNode
  modal?: ReactNode
  /* Bottom content is really just for avoiding a lot of AboutYou changes.
  Ideally this layout would be tweaked if we were to also rewrite AboutYou */
  bottomContent?: ReactNode
  closeButton?: boolean
}

const FleLayout: FC<FleLayoutProps> = ({ modal, ...otherProps }) => (
  <LayoutBindHeight>
    <Title title={l`fle.title`} />
    <LogoHeaderBar />
    <MainFleSection {...otherProps} />
    {modal ? <div>{modal}</div> : null}
  </LayoutBindHeight>
)

const LogoHeaderBar = () => (
  <div className="dn flex-ns justify-center" style={{ marginBottom: "32px" }}>
    <div
      className="ph4 w-100"
      style={{
        maxWidth: "1224px"
      }}
    >
      <MultiPathSVG iconName="carrot-white" />
    </div>
  </div>
)

type MainFleSectionProps = {
  children: ReactNode
  bottomContent?: ReactNode
  closeButton?: boolean
}

function CloseButton(): JSX.Element {
  const history = useHistory()

  return (
    <button
      className="input-reset pointer pa0 bw0 bg-transparent black-60 hover-black animate-all fr"
      onClick={() => history.push("/")}
    >
      <img alt="close" src="/images/icn-close-modal.svg" />
    </button>
  )
}

function MainFleSection({ children, bottomContent, closeButton }: MainFleSectionProps): JSX.Element {
  return (
    <FlexContainer justifyContent="center" width="100%">
      <MainContainer>
        <FlexContainer height="100%" direction="column" justifyContent="space-between">
          <div>
            <FlexContainer justifyContent="flex-end" padding="medium">
              {closeButton && <CloseButton />}
            </FlexContainer>
            <Container paddingLeftRight="huge">{children}</Container>
          </div>
          {bottomContent}
        </FlexContainer>
      </MainContainer>
    </FlexContainer>
  )
}

export { FleLayout }
